export default class Functions {
    
    /**
     * constructor
     * @returns {Functions|*}
     */
    constructor()
    {
        
        if ( !Functions.instance ) {
            
            Functions.instance = this
            
        }
        
        return Functions.instance
        
    }
    
    hash( string, method )
    {
        
        return new Promise( ( resolve ) => {
            
            const utf8 = new TextEncoder( 'utf-8' ).encode( string );
            switch( method )
            {
                case 'sha256':
                    return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
                        
                        const hashArray = Array.from(new Uint8Array(hashBuffer));
                        
                        const hashHex = hashArray
                            .map((bytes) => bytes.toString(16).padStart(2, '0'))
                            .join('');
                        return resolve( hashHex );
                        
                    });
                case 'sha512':
                    crypto.subtle.digest("SHA-512", utf8 ).then(hashBuffer => {
                        return resolve( Array.prototype.map.call(new Uint8Array(hashBuffer), x=>(('00'+x.toString(16)).slice(-2))).join('') );
                    });
                    break
            }
            
        })
        
    }
    
    validate( value, rule, check )
    {
        switch( rule )
        {
            case 'string_len_gt':
                return value.length && value.length > check
            case 'string_len_lt':
                return value.length && value.length < check
            case 'date_years_gt':
                return check <= ( new Date( Date.now() - new Date( value ).getTime() ).getUTCFullYear() - 1970 )
        }
    }
    
    skip( event )
    {
        event.stopPropagation()
        event.preventDefault()
    }
    
    /**
     * toHtml
     * @param body
     * @returns {string}
     */
    toHtml( body )
    {
        
        if( undefined === body
            || 'undefined' === body )
        {
            return ''
        }
        
        let nuBody = '',
            rows   = body.split( /\n/g ),
            ulOpen = false
        
        for( let r in rows )
        {
            if( '-' === rows[ r ].substr( 0, 1 )
                && '--' !== rows[ r ].substr( 0, 2 ) )
            {
                let line = rows[ r ].substr( 1 ).trim()
                if( !ulOpen )
                {
                    nuBody += '<ul>'
                    ulOpen = true
                }
                nuBody += '<li>' + line + '</li>'
            }
            else
            {
                if( ulOpen )
                {
                    nuBody += '</ul>'
                    ulOpen = false
                }
                nuBody += rows[ r ] + '\n'
            }
        }
        if( ulOpen )
        {
            nuBody += '</ul>'
        }
        
        body = nuBody
        
        body = body.replace( /\n/g, '<br/>' )
        body = body.replace( /<br>/g, '<br/>' )
        body = body.replace( /\*([^\\*]*)\*/g, '<span class="bold">$1</span>' )
        body = body.replace( /_([^\\*]*)_/g, '<u>$1</u>' )
        body = body.replace( /~([^\\*]*)~/g, '<em>$1</em>' )
        body = body.replace( /--([^\\*]*)--/g, '<s>$1</s>' )
        
        //body = body.replace( /&amp;([^\\*]*)&amp;/g, '<span class="comic">$1</span>' )
        
        let cleanup     = body.split( '<br/>' ),
            cleanedBody = [],
            textFound   = false,
            addOne      = 1
        
        for( let i = ( cleanup.length - 1 ); i >= 0; i -= 1 )
        {
            if( '' !== cleanup[ i ].trim() || textFound )
            {
                cleanedBody.push( cleanup[ i ] )
                textFound = true
            }
            else
            {
                addOne++
            }
        }
        
        // remove hartnäckige leerzeile am Ende
        if( '' === cleanedBody[ ( cleanup.length - addOne ) ] )
        {
            cleanedBody.pop()
        }
        
        body = cleanedBody.reverse().join( '<br/>' )
        
        return body
        
    }
    
    /**
     * ucFirst
     * @param string
     * @returns {string}
     */
    ucFirst( string )
    {
        return string.charAt( 0 ).toUpperCase() + string.slice( 1 )
    }
    
    /**
     * removeFromArray
     * @param array
     * @param what
     */
    removeFromArray( array, what )
    {
        
        if( undefined === array )
        {
            return
        }
        
        let index = array.indexOf( what )
        if( -1 < index )
        {
            array.splice( index, 1 )
        }
        
    }
    
}